import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBySubTopicStatus',
  pure: true,
})
export class FilterBySubTopicStatusPipe implements PipeTransform {
  transform(subTopics: any[], oldOption: string, newOption: string): any[] {
    if (!Array.isArray(subTopics)) return [];

    const isCustomCondition =
      (oldOption === 'Custom' && newOption === 'Custom') ||
      (oldOption === 'None' && newOption === 'Custom') ||
      (oldOption === null && newOption === 'Custom') ||
      (oldOption === 'Custom' && newOption === 'None');

    if (!isCustomCondition) {
      return subTopics.filter((s) => s.status === 'Current');
    }

    return subTopics;
  }
}
